import request from "root/js/request";

export const getIncomeTerms = async ({ cabinet_id, marketplace, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/income_terms/",
    method: "get",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};

export const postIncomeTermsInBulk = async ({ cabinet_id, marketplace, items, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/income_terms/bulk_update/",
    method: "post",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
    data: items,
  });
  return response.data;
};

export const postUploadIncomeTerms = async ({ cabinet_id, marketplace }, formData) => {
  const file = formData.get("excel_file");
  if (file) {
    formData.delete("excel_file");
    formData.append("file", file);
  }
  formData.append("cabinet_id", cabinet_id);

  const response = await request({
    url: `/api/analytics/cross-mp/income_terms/upload_income_terms/`,
    method: "post",
    params: {
      cabinet_id,
      marketplace,
    },
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${localStorage.getItem("token")}`,
    },
  });

  return response;
};
